module.exports = __webpack_public_path__ + "static/p4ktldr-0ce8972e8bc318574c58374cea9cf611.jpg";